import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import * as D from '../../../deps';

import './BackstagePodcastProgramSubheaderSmall.scss';

const BackstagePodcastProgramSubheaderSmall = props => {
  return (
    <div className='BackstagePodcastProgramSubheaderSmall'>
      <D.PodcastProgramMetadata episodeCount={props.episodeCount} showNewBadge={false} />
    </div>
  );
};

BackstagePodcastProgramSubheaderSmall.propTypes = {
  episodeCount: PropTypes.number,
};

export function mapStateToProps(state, ownProps) {
  const programAnnotation = D.getAnnotationsById(state, ownProps.programId);

  return {
    episodeCount: D.Utils.Core.getFromMap(programAnnotation, 'episodeCount'),
  };
}

export default connect(mapStateToProps)(BackstagePodcastProgramSubheaderSmall);
